/**
 * HUD：红心与星星计数。订阅会话事件自更新。
 */

export class Hud {
    /**
     * @param {object} els
     * @param {HTMLElement} els.hearts
     * @param {HTMLElement} els.progressLabel
     */
    constructor(els) {
        this.els = els;
        /** @type {Array<() => void>} */
        this._unsubs = [];
        /** @type {HTMLElement[]} */
        this._heartEls = [];
        this.session = null;
    }

    /**
     * @param {import('../core/session.js').GameSession} session
     */
    mount(session) {
        this.unmount();
        this.session = session;

        this._buildHearts(session.maxLives);
        this._renderHearts(session.remainingLives);
        this._renderProgress();

        this._unsubs.push(
            session.on('livesChanged', v => this._renderHearts(v)),
            session.on('lifeLost', v => this._breakHeart(v)),
            session.on('cellChanged', () => this._renderProgress()),
            session.on('reset', () => {
                this._renderHearts(session.remainingLives);
                this._renderProgress();
            }),
        );
    }

    unmount() {
        for (const off of this._unsubs) off();
        this._unsubs = [];
        this.session = null;
    }

    /** @param {number} max */
    _buildHearts(max) {
        this.els.hearts.replaceChildren();
        this._heartEls = [];
        for (let i = 0; i < max; i++) {
            const h = document.createElement('span');
            h.className = 'sd-heart';
            this.els.hearts.appendChild(h);
            this._heartEls.push(h);
        }
    }

    /** @param {number} remaining */
    _renderHearts(remaining) {
        this._heartEls.forEach((h, i) => {
            h.classList.toggle('sd-heart--full', i < remaining);
        });
    }

    /**
     * 掉命时让刚熄灭的那颗心播碎裂动画。
     * @param {number} remaining 扣血后的剩余生命
     */
    _breakHeart(remaining) {
        const h = this._heartEls[remaining];
        if (!h) return;
        h.classList.remove('sd-heart--breaking');
        void h.offsetWidth;
        h.classList.add('sd-heart--breaking');
    }

    _renderProgress() {
        if (!this.session) return;
        const placed = this.session.board.totalStars;
        const total = this.session.board.stars * this.session.dim;
        this.els.progressLabel.textContent = `${placed}/${total}`;
    }
}
